export const animateOverflow = (el, phase, {
  duration = 500,
  background = '#fff',
} = {}) => {
  if (el) {
    const { scrollWidth, clientWidth } = el;

    if (scrollWidth > clientWidth) {
      let style = {
        opacity: 1,
        'pointer-events': 'none',
        transform: 'scaleX(1)',
        transition: `transform ${duration}ms ease-in-out, opacity ${duration}ms ease-in`,
        'transition-delay': `${duration / 2}ms`,
        'z-index': 99,
      };
      let fadeEffect = '';
      const fadeElement = phase === 'init' ? document.createElement('span') :
        el?.getElementsByClassName('overflow-overlay');

      // Calculate scale transform for animation.
      const transform = el.scrollWidth / el.clientWidth;

      switch (phase) {
        case 'init':
          el?.classList.add('overflowing');
          fadeEffect = getFadeEffect({ color: background, fullWidth: clientWidth, prevStyles: style });
          if (fadeElement?.length > 0) {
            for (let i = 0; i < fadeElement.length; i += 1) {
              fadeElement[i].setAttribute('style', fadeEffect);
            }
          }
          else {
            fadeElement.classList.add('overflow-overlay');
            fadeElement.setAttribute('style', fadeEffect);
            el?.appendChild(fadeElement);
          }
          break;
        case 'animate':
          style = {
            opacity: 0,
            'pointer-events': 'none',
            transform: `scaleX(${transform})`,
            transition: `transform ${duration}ms ease-in-out, opacity ${duration}ms ease-in`,
            'transition-delay': `${duration / 2}ms`,
            'z-index': 99,
          };
          style = getFadeEffect({ color: background, fullWidth: clientWidth, prevStyles: style });
          if (fadeElement.length > 0) {
            for (let i = 0; i < fadeElement.length; i += 1) {
              fadeElement[i]?.setAttribute('style', style);
            }
            el?.classList.remove('overflowing');
            el?.classList.add('transformed');
          }
          break;
        case 'destroy':
          el?.classList.remove('overflowing');
          el?.classList.remove('transformed');
          if (fadeElement.length > 0) {
            for (let i = 0; i < fadeElement.length; i += 1) {
              el?.removeChild(fadeElement[i]);
            }
          }
          break;
        default:
      }
    }
  }
};

// Copied from overflow-fade mixin.
// TODO: convert all sass mixins to javascript to unify sass and react inline styles.
export const getFadeEffect = ({
  direction = 'left',
  size = 35,
  fullWidth = 0,
  prevStyles = {},
}) => {
  const createGradient = (deg) => {
    if (fullWidth > 0) {
      const stop = fullWidth / size;
      return `linear-gradient(${deg}deg, #000, #000 ${stop}%, transparent)`;
    }
    return `linear-gradient(${deg}deg, #000, transparent)`;
  };

  let styles = {
    ...prevStyles,
    'mask-image': createGradient(270),
    '-webkit-mask-image': createGradient(270),
    display: 'block',
    position: 'absolute',
  };

  switch (direction) {
    case 'up':
      styles = {
        ...styles,
        'mask-image': createGradient(0),
        '-webkit-mask-image': createGradient(0),
        top: 0,
        right: 0,
        height: `${size}px`,
        width: '100%',
      };
      break;
    case 'down':
      styles = {
        ...styles,
        'mask-image': createGradient(180),
        '-webkit-mask-image': createGradient(180),
        bottom: 0,
        right: 0,
        height: `${size}px`,
        width: '100%',
      };
      break;
    case 'right':
      styles = {
        ...styles,
        'mask-image': createGradient(90),
        '-webkit-mask-image': createGradient(90),
        top: 0,
        left: fullWidth > 0 ? 'auto' : 0,
        right: fullWidth > 0 ? 0 : 'auto',
        height: '100%',
        width: `${fullWidth > 0 ? fullWidth : size}px`,
      };
      break;
    default:
      styles = {
        ...styles,
        top: 0,
        right: fullWidth > 0 ? 'auto': 0,
        left: fullWidth > 0 ? 0 : 'auto',
        height: '100%',
        width: `${fullWidth > 0 ? fullWidth : size}px`,
      };
  }
  return convertStyles(styles);

};

export const animateWidth = (el, newWidth, duration = 500) => {
  if (el) {
    const scale = newWidth / el.clientWidth;
    const style = {
      transform: `scaleX(${scale})`,
      'transform-origin': 'left center',
      transition: `transform ${duration}ms ease-out`,
    };
    el.setAttribute('style', convertStyles(style));
  }
};

const convertStyles = (styles) => {
  return Object.keys(styles).reduce((prev, style) => {
    return `${prev} ${style}:${styles[style]};`;
  }, '');
};
